module.exports = __webpack_public_path__ + "img/egg_squares_sad.2afb963d.svg";